class webglPlayer {
    pureWhiteBg = true;
    jsonData = [];
    modelPaths = {};
    cModelPaths = {};
    models = {};
    parts = [];
    root;
    viewerLoaded = false;
    viewer = null;
    vjsonFile = '';
	rootScaleFactor = 1 / 10.0;
    devicePixelRatio = 2;

    constructor() {
    }

    init(id, data) {
        this.resetAllVariables();
        
        const canvas = document.getElementById(id);
        canvas.width = canvas.offsetWidth;
        canvas.height = window.innerHeight;
        this.jsonData = data;
        this.vjsonFile = three_d_static_data[0]['vjson'];
        
        $("#webgl_vdb_setting_canvas_loader").show();

        setupCoreWebGlViewer(
            { canvas },
            { depthTonemap: this.pureWhiteBg }
        ).then(async (viewer) => {
            this.viewer = viewer;
            this.viewer.renderEnabled = false;
            this.setupThreeDCanvas(viewer);
            await this.afterInitViewer(viewer);
			this.viewer.scene.modelRoot.scale.setScalar(0.05); 
            // this.viewer.scene.modelRoot.scale.setScalar(0.1);
			// this.viewer.fitToView();
            // this.viewer.renderer.displayCanvasScaling = Math.min(1.5, window.devicePixelRatio);
            this.viewer.renderEnabled = true;
            await this.viewer.addPlugin(CameraViewPlugin);// this is for smooth position change

            $("#webgl_vdb_setting_canvas_loader").hide();
        });
        
    }

    async update(id, data) {
        this.jsonData = data;
        this.vjsonFile = three_d_static_data[0]['vjson'];
        
        $("#webgl_vdb_setting_canvas_loader").show();

        this.generateModelPaths();
        await this.updateModels();
        $("#webgl_vdb_setting_canvas_loader").hide();
    }

    generateModelPaths() {
        this.jsonData.forEach(d => {
            if (d.option_type == 'model') {
                this.modelPaths[d.option_identifier] = d.option_value;
                if(!this.cModelPaths[d.option_identifier]) this.cModelPaths[d.option_identifier] = '';
                if(!this.models[d.option_identifier]) this.models[d.option_identifier] = null;
                if (!this.parts.includes(d.option_identifier)) this.parts.push(d.option_identifier);
            }
        })
    }

    async setMetalMaterial(colorFile, namingConvention) {
        const metalMaterial = await this.viewer
            .getManager()
            .importer.importSinglePath(colorFile);
        let objs = [];
        namingConvention = namingConvention.split(',').map(name => name.trim()) || [];

        objs = this.parts.map(part => this.models[part]);
        if (!objs.length) return;

        objs.forEach(obj => {
            obj.modelObject.traverse((o) => {
                if (!o || !o.material) return;
                if (!o.userData.originalMaterialName) o.userData.originalMaterialName = o.material.name;
                if (namingConvention.includes(o.userData.originalMaterialName)) {
                    o.setMaterial(metalMaterial);
                }
            });
            this.viewer.scene.setDirty({ sceneUpdate: true });
        });
    }

    async setDiamondMaterial(colorFile, namingConvention) {
        const diamondMaterial = await this.viewer
            .getManager()
            .importer.importSinglePath(colorFile);
        let objs = [];
        namingConvention = namingConvention.split(',').map(name => name.trim()) || [];

        objs = this.parts.map(part => this.models[part]);
        if (!objs.length) return;
        objs.forEach(obj => {
            obj.modelObject.traverse((o) => {
                if (!o || !o.material) return;
                if (!o.userData.originalMaterialName) o.userData.originalMaterialName = o.material.name;
                if (namingConvention.includes(o.userData.originalMaterialName)) {
                    this.viewer.getPluginByType("Diamond").prepareDiamondMesh(o, { cacheKey: o.material.name, normalMapRes: 512 });
                    o.setMaterial(diamondMaterial);
                }
            });
            this.viewer.scene.setDirty({ sceneUpdate: true });
        });
    }

    async changeAutoRotate(flag=true) {
        //const autoRotate = this.viewer.scene.activeCamera.controls.autoRotate;
        this.viewer.scene.activeCamera.controls.autoRotate = flag;
    }
    async changeAutoRotateSpeed(speed = 2) {
        this.viewer.scene.activeCamera.controls.autoRotateSpeed = speed;
    }
    async changeCameraAngle(x,y,z) {
      //this.viewer.scene.activeCamera.position.set(x, y, z); 
      //this.viewer.scene.activeCamera.positionUpdated();
      if(this.viewer && this.viewer.scene){
          const camViewPlugin = this.viewer.getPlugin(CameraViewPlugin);
          let view = camViewPlugin.getCurrentCameraView(this.viewer.scene.activeCamera);
          view.position.set(x, y, z);
          camViewPlugin.camViews.push(view);
          await camViewPlugin.animateToView(camViewPlugin.camViews[camViewPlugin.camViews.length-1], 1500);
      }
    }

    async afterInitViewer() {
		await this.viewer.getManager().addFromPath(this.vjsonFile);	
        this.viewer.getPlugin(InteractionPromptPlugin).enabled = false
        this.root = await this.viewer.createObject3D();
		this.viewerLoaded = true;        
        this.generateModelPaths();
        await this.updateModels();
        // frontend/js/assets/hdr/sceneExportAllViewerConfig.vjson
    }

    async updateModels() {
        let viewer = this.viewer;
        if (!viewer || !this.viewerLoaded) return;
        const manager = viewer.getPlugin(AssetManagerPlugin);
        await Promise.all(this.parts.map(async part => {
            if (this.modelPaths[part] != this.cModelPaths[part]) {
                const modelPath = this.modelPaths[part];
                this.cModelPaths[part] = modelPath;
                const modelvalue = (
                    await manager.addFromPath(modelPath, {
                        autoCenter: false,
                        autoScale: false
                    })
                )[0];
                if (this.models[part]) {
                    // this.models[part].dispose();
                    this.models[part].modelObject.removeFromParent();
                    this.models[part] = undefined;
                }
                this.models[part] = modelvalue;
                if (this.models[part]) {
                    this.root.modelObject.add(this.models[part].modelObject);
                }
            }
        }));
        await Promise.all(this.jsonData.map(async d => {
            if (d.option_type == 'material') {
                const colorFile = d.option_value;
                const fileExt = colorFile?.split('.')[colorFile?.split('.').length - 1];
                if (fileExt == 'pmat') await this.setMetalMaterial(colorFile, d.option_identifier);
                else await this.setDiamondMaterial(colorFile, d.option_identifier);
            }
        }));
        this.viewer.scene.setDirty();
    }

    checkForMobile = () => {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
        return check
    };
      
    setupThreeDCanvas = (viewer) => {
        if (!this.checkForMobile()) {
            this.viewer.renderer.displayCanvasScaling = 2;
        } else {
            this.viewer.renderer.displayCanvasScaling = Math.min(this.devicePixelRatio, 2);
        }
        // this.viewer.getPluginByType('AssetManagerLoadingBarPlugin').enabled = false;
    };
    
    resetAllVariables(){
        this.pureWhiteBg = true;
        this.jsonData = [];
        this.modelPaths = {};
        this.cModelPaths = {};
        this.models = {};
        this.parts = [];
        this.root;
        this.viewerLoaded = false;
        this.viewer = null;
        this.vjsonFile = '';
    }
}
window.player = new webglPlayer();